<template>
    <li v-on:click="toggle" v-bind:class="{ 'mr-3': (index % 2 == 0) }" class="block float-left mb-3 papsi-thumbnail-w">
        <div class="bg-white rounded shadow overflow-hidden w-full">
            <div v-bind:style="[ getSource() ]" v-bind:class="[ tone, getSize() ]" class="bg-grey-light bg-center bg-no-repeat papsi-thumbnail-box">
                <div v-show="status" class="w-menu h-menu rounded-full">
                    <img v-bind:src="getIcon()" class="mt-1 ml-1" />
                </div>
            </div>
            <div v-bind:class="{
                'bg-theme-bod' : status && color == 'bg-theme-bod',
                'bg-theme-elecom' : status && color == 'bg-theme-elecom',
                'bg-theme-adcom' : status && color == 'bg-theme-adcom',
                'text-white' : status,
            }" class="text-center py-1 uppercase papsi-thumbnail-text-h">
                <div v-text="name" class="px-4 break-words text-xs font-bold"></div>
                <div v-text="category" v-show="group == 'bod'" v-bind:class="{
                    'opacity-75' : status,
                }" class="text-xs"></div>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    name: 'v-vote-item',
    props: {
        id: {
            type: String,
        },
        group: {
            type: String,
        },
        index: {
            type: Number,
        },
        name: {
            type: String,
        },
        type: {
            type: Number,
        },
        category: {
            type: String,
        },
        selected: {
            type: Boolean,
        },
        count: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
        },
        freeze: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: 'bg-theme-bod',
        },
        available: {
            type: Boolean,
        }
    },
    data() {
        return {
            status: false,
            tone: 'papsi-thumbnail-grayscale-0',
            theme: 'bg-theme-bod',
            path: null,
            path_g: null,
            path_y: null,
            loaded: false,
        }
    },
    mounted() {
        this.status = this.selected;
        // this.tone = (this.freeze && !this.status) ? 'papsi-thumbnail-grayscale' : 'papsi-thumbnail-grayscale-0';
        this.path_g = process.env.VUE_APP_MEDIA_URL + "images/candidates/g/" + this.id + ".jpg";
        this.path_y = process.env.VUE_APP_MEDIA_URL + "images/candidates/y/" + this.id + ".jpg";
        this.path = this.status ? this.path_y : this.path_g;

        this.loadImage1(this.path_g);
    },
    methods: {
        loadImage1(src) {
            let that = this,
                img = new Image();
                img.src = src;
                img.onload = function() {
                    that.loadImage2(that.path_y);
                };
        },
        loadImage2(src) {
            let that = this,
                img = new Image();
                img.src = src;
                img.onload = function() {
                    let t = setTimeout(function() {
                        that.loaded = true;
                        clearTimeout(t);
                    }, 500);
                };
        },
        toggle() {
            if(!this.freeze || (this.count <= this.max && this.available) || this.status) {
                if(this.count < this.max) {
                    this.status = !this.status;
                    this.$emit('toggled', this.id);
                }
                else
                {
                    if(this.status) {
                        this.status = false;
                        this.$emit('toggled', this.id);
                    }
                    else
                    {
                        this.$emit('overselect', this.id);
                    }
                }
            }
            else if(this.count == this.max) {
                this.$emit('overselect', this.id);
            }
            else if(!this.available && !this.status) {
                this.$emit('overselectedBOD', this.type);
            }
        },
        getSize() {
            return this.loaded ? 'bg-cover' : null;
        },
        getSource() {
            return this.loaded ? "background-image: url('" + this.path + "')" : "background-image: url('" + process.env.VUE_APP_MEDIA_URL + "images/loader/spinner.gif')";
        },
        getIcon() {
            if(this.group == 'elecom') {
                return require("@/assets/icons/selected/papsi_selected_elecom.svg");
            }
            else if(this.group == 'audit') {
                return require("@/assets/icons/selected/papsi_selected_audit.svg");
            }
            else {
                return require("@/assets/icons/selected/papsi_selected_bod.svg");
            }
        },
    },
    watch: {
        selected(status) {
            this.status = status;

            if(this.status)
            {
                this.path = this.path_y;
                this.$emit('selected', this.id);
            }
            else 
            {
                this.path = this.path_g;
                this.$emit('unselected', this.id);
            }
        },
        // freeze(n) {
        //     this.tone = (n && !this.status) ? 'papsi-thumbnail-grayscale' : 'papsi-thumbnail-grayscale-0';
        // }
    }
}
</script>

<style scoped>
.papsi-thumbnail-w {
    width: calc(50% - 6px);
}
.papsi-thumbnail-box {
    width: 100%;
    height: 0px;
    padding-bottom: 100%;
}
.papsi-thumbnail-text-h {
    height: 68px;
    line-height: 20px;
}
.papsi-thumbnail-grayscale {
    -webkit-transform: translateZ(0);
    -webkit-filter: grayscale(1);
    filter: grayscale(100%);
}
.papsi-thumbnail-grayscale-0 {
    -webkit-transform: translateZ(0);
    -webkit-filter: grayscale(0);
    filter: grayscale(0%);
}
</style>